import React from 'react';
import PropTypes from 'prop-types';
import { Button as BootstrapButton } from 'reactstrap';
import './styles/Button.scss';

const Button = ({ text, style, onClick, buttonClass, ...restParams }) => (
  <div className="button-wrapper">
    <BootstrapButton
      onClick={ onClick }
      className={ `button ${buttonClass}` }
      style={ style }
      { ...restParams }
    >
      {text}
    </BootstrapButton>
  </div>
);

Button.propTypes = {
  style: PropTypes.shape({}),
  text: PropTypes.string,
  onClick: PropTypes.func,
  buttonClass: PropTypes.string
};

Button.defaultProps = {
  style: {},
  text: '',
  onClick: () => {},
  buttonClass: ''
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.js